export default __webpack_public_path__ + "static/media/iphone-12--black.628edd01.png";